module.exports = __webpack_public_path__ + "img/Logo.24d23a66.svg";